var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "p",
      {
        ref: "triggerTitle",
        staticClass: "title",
        on: { click: _vm.toggleDropdown },
      },
      [_vm._v(_vm._s(_vm.time) + _vm._s(_vm.title))]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showSelect,
            expression: "showSelect",
          },
        ],
        staticClass: "select",
      },
      [
        _c(
          "p",
          {
            staticClass: "select-item",
            on: {
              click: function ($event) {
                return _vm.handleSelect(0)
              },
            },
          },
          [_vm._v("海外事业部运营报表")]
        ),
        _c(
          "p",
          {
            staticClass: "select-item",
            on: {
              click: function ($event) {
                return _vm.handleSelect(1)
              },
            },
          },
          [_vm._v("汇嘉信运营报表")]
        ),
      ]
    ),
    _c("div", { staticClass: "warp" }, [
      _c("div", { staticClass: "tabs" }, [
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.isActive === 0 },
            on: {
              click: function ($event) {
                return _vm.handleTabChange(0)
              },
            },
          },
          [_vm._v(" 系统客户制单数据统计 ")]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.isActive === 1 },
            on: {
              click: function ($event) {
                return _vm.handleTabChange(1)
              },
            },
          },
          [_vm._v(" 系统账号制单数据统计 ")]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.isActive === 2 },
            on: {
              click: function ($event) {
                return _vm.handleTabChange(2)
              },
            },
          },
          [_vm._v(" 空运提单情况汇总 ")]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.isActive === 3 },
            on: {
              click: function ($event) {
                return _vm.handleTabChange(3)
              },
            },
          },
          [_vm._v(" 海运提单情况汇总 ")]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.isActive === 4 },
            on: {
              click: function ($event) {
                return _vm.handleTabChange(4)
              },
            },
          },
          [_vm._v(" 当月营收情况统计 ")]
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "data sumData" },
      [
        _c("BaseTable", {
          attrs: {
            id: "baseTable",
            height: 640,
            tableData: {
              fileds: _vm.fileds,
              columns: _vm.columns,
            },
            isPager: false,
            headerCellStyle: {
              "font-size": "14px",
              color: "#FFFFFF",
              background: " rgb(18,88,188)",
            },
            "show-summary": true,
            getSummaries: _vm.getSummaries,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }